"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REQUIRED_METHODS = exports.REQUIRED_EVENTS = exports.OPTIONAL_METHODS = exports.OPTIONAL_EVENTS = exports.EthereumProvider = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _events = require("events");

var _utils = require("@walletconnect/utils");

var _universalProvider = require("@walletconnect/universal-provider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var $ = "wc",
    j = "ethereum_provider",
    q = "".concat($, "@2:").concat(j, ":"),
    N = "https://rpc.walletconnect.com/v1/",
    p = ["eth_sendTransaction", "personal_sign"],
    D = ["eth_accounts", "eth_requestAccounts", "eth_sendRawTransaction", "eth_sign", "eth_signTransaction", "eth_signTypedData", "eth_signTypedData_v3", "eth_signTypedData_v4", "wallet_switchEthereumChain", "wallet_addEthereumChain", "wallet_getPermissions", "wallet_requestPermissions", "wallet_registerOnboarding", "wallet_watchAsset", "wallet_scanQRCode"],
    u = ["chainChanged", "accountsChanged"],
    U = ["message", "disconnect", "connect"];
exports.OPTIONAL_EVENTS = U;
exports.REQUIRED_EVENTS = u;
exports.OPTIONAL_METHODS = D;
exports.REQUIRED_METHODS = p;

var Q = Object.defineProperty,
    L = Object.defineProperties,
    G = Object.getOwnPropertyDescriptors,
    _ = Object.getOwnPropertySymbols,
    K = Object.prototype.hasOwnProperty,
    V = Object.prototype.propertyIsEnumerable,
    y = function y(a, t, s) {
  return t in a ? Q(a, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: s
  }) : a[t] = s;
},
    C = function C(a, t) {
  for (var s in t || (t = {})) {
    K.call(t, s) && y(a, s, t[s]);
  }

  if (_) {
    var _iterator = _createForOfIteratorHelper(_(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var s = _step.value;
        V.call(t, s) && y(a, s, t[s]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
},
    O = function O(a, t) {
  return L(a, G(t));
};

function I(a) {
  return Number(a[0].split(":")[1]);
}

function w(a) {
  return "0x".concat(a.toString(16));
}

function W(a) {
  var t = a.chains,
      s = a.optionalChains,
      i = a.methods,
      n = a.optionalMethods,
      e = a.events,
      c = a.optionalEvents,
      h = a.rpcMap;
  if (!(0, _utils.isValidArray)(t)) throw new Error("Invalid chains");

  var o = t,
      r = i || p,
      E = e || u,
      M = _defineProperty({}, I(o), h[I(o)]),
      f = {
    chains: o,
    methods: r,
    events: E,
    rpcMap: M
  },
      l = e === null || e === void 0 ? void 0 : e.filter(function (g) {
    return !u.includes(g);
  }),
      d = i === null || i === void 0 ? void 0 : i.filter(function (g) {
    return !p.includes(g);
  });

  if (!s && !c && !n && !(l != null && l.length) && !(d != null && d.length)) return {
    required: f
  };
  var b = (l === null || l === void 0 ? void 0 : l.length) && (d === null || d === void 0 ? void 0 : d.length) || !s,
      A = {
    chains: _toConsumableArray(new Set(b ? o.concat(s || []) : s)),
    methods: _toConsumableArray(new Set(r.concat(n || []))),
    events: _toConsumableArray(new Set(E.concat(c || []))),
    rpcMap: h
  };
  return {
    required: f,
    optional: A
  };
}

var m = /*#__PURE__*/function () {
  function m() {
    var _this = this;

    _classCallCheck(this, m);

    this.events = new _events.EventEmitter(), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = q, this.on = function (t, s) {
      return _this.events.on(t, s), _this;
    }, this.once = function (t, s) {
      return _this.events.once(t, s), _this;
    }, this.removeListener = function (t, s) {
      return _this.events.removeListener(t, s), _this;
    }, this.off = function (t, s) {
      return _this.events.off(t, s), _this;
    }, this.parseAccount = function (t) {
      return _this.isCompatibleChainId(t) ? _this.parseAccountId(t).address : t;
    }, this.signer = {}, this.rpc = {};
  }

  _createClass(m, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(t) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.signer.request(t, this.formatChainId(this.chainId));

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "sendAsync",
    value: function sendAsync(t, s) {
      this.signer.sendAsync(t, s, this.formatChainId(this.chainId));
    }
  }, {
    key: "connected",
    get: function get() {
      return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
  }, {
    key: "enable",
    value: function () {
      var _enable = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this.session;

                if (_context2.t0) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.connect();

              case 4:
                _context2.next = 6;
                return this.request({
                  method: "eth_requestAccounts"
                });

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function enable() {
        return _enable.apply(this, arguments);
      }

      return enable;
    }()
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4(t) {
        var _this2 = this;

        var _W, s, i, n, e;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.signer.client) {
                  _context4.next = 2;
                  break;
                }

                throw new Error("Provider not initialized. Call init() first");

              case 2:
                this.loadConnectOpts(t);
                _W = W(this.rpc), s = _W.required, i = _W.optional;
                _context4.prev = 4;
                _context4.next = 7;
                return new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(c, h) {
                    var o;
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _this2.rpc.showQrModal && ((o = _this2.modal) == null || o.subscribeModal(function (r) {
                              !r.open && !_this2.signer.session && (_this2.signer.abortPairingAttempt(), h(new Error("Connection request reset. Please try again.")));
                            }));
                            _context3.next = 3;
                            return _this2.signer.connect(O(C({
                              namespaces: _defineProperty({}, _this2.namespace, s)
                            }, i && {
                              optionalNamespaces: _defineProperty({}, _this2.namespace, i)
                            }), {
                              pairingTopic: t === null || t === void 0 ? void 0 : t.pairingTopic
                            })).then(function (r) {
                              c(r);
                            })["catch"](function (r) {
                              h(new Error(r.message));
                            });

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 7:
                n = _context4.sent;

                if (n) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return");

              case 10:
                this.setChainIds(this.rpc.chains);
                e = (0, _utils.getAccountsFromNamespaces)(n.namespaces, [this.namespace]);
                this.setAccounts(e), this.events.emit("connect", {
                  chainId: w(this.chainId)
                });
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](4);
                throw this.signer.logger.error(_context4.t0), _context4.t0;

              case 18:
                _context4.prev = 18;
                this.modal && this.modal.closeModal();
                return _context4.finish(18);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 15, 18, 21]]);
      }));

      function connect(_x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = this.session;

                if (!_context5.t0) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 4;
                return this.signer.disconnect();

              case 4:
                this.reset();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "isWalletConnect",
    get: function get() {
      return !0;
    }
  }, {
    key: "session",
    get: function get() {
      return this.signer.session;
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this3 = this;

      this.signer.on("session_event", function (t) {
        var s = t.params,
            i = s.event;
        i.name === "accountsChanged" ? (_this3.accounts = _this3.parseAccounts(i.data), _this3.events.emit("accountsChanged", _this3.accounts)) : i.name === "chainChanged" ? _this3.setChainId(_this3.formatChainId(i.data)) : _this3.events.emit(i.name, i.data), _this3.events.emit("session_event", t);
      }), this.signer.on("chainChanged", function (t) {
        var s = parseInt(t);
        _this3.chainId = s, _this3.events.emit("chainChanged", w(_this3.chainId)), _this3.persist();
      }), this.signer.on("session_update", function (t) {
        _this3.events.emit("session_update", t);
      }), this.signer.on("session_delete", function (t) {
        _this3.reset(), _this3.events.emit("session_delete", t), _this3.events.emit("disconnect", O(C({}, (0, _utils.getSdkError)("USER_DISCONNECTED")), {
          data: t.topic,
          name: "USER_DISCONNECTED"
        }));
      }), this.signer.on("display_uri", function (t) {
        var s, i;
        _this3.rpc.showQrModal && ((s = _this3.modal) == null || s.closeModal(), (i = _this3.modal) == null || i.openModal({
          uri: t
        })), _this3.events.emit("display_uri", t);
      });
    }
  }, {
    key: "switchEthereumChain",
    value: function switchEthereumChain(t) {
      this.request({
        method: "wallet_switchEthereumChain",
        params: [{
          chainId: t.toString(16)
        }]
      });
    }
  }, {
    key: "isCompatibleChainId",
    value: function isCompatibleChainId(t) {
      return typeof t == "string" ? t.startsWith("".concat(this.namespace, ":")) : !1;
    }
  }, {
    key: "formatChainId",
    value: function formatChainId(t) {
      return "".concat(this.namespace, ":").concat(t);
    }
  }, {
    key: "parseChainId",
    value: function parseChainId(t) {
      return Number(t.split(":")[1]);
    }
  }, {
    key: "setChainIds",
    value: function setChainIds(t) {
      var _this4 = this;

      var s = t.filter(function (i) {
        return _this4.isCompatibleChainId(i);
      }).map(function (i) {
        return _this4.parseChainId(i);
      });
      s.length && (this.chainId = s[0], this.events.emit("chainChanged", w(this.chainId)), this.persist());
    }
  }, {
    key: "setChainId",
    value: function setChainId(t) {
      if (this.isCompatibleChainId(t)) {
        var s = this.parseChainId(t);
        this.chainId = s, this.switchEthereumChain(s);
      }
    }
  }, {
    key: "parseAccountId",
    value: function parseAccountId(t) {
      var _t$split = t.split(":"),
          _t$split2 = _slicedToArray(_t$split, 3),
          s = _t$split2[0],
          i = _t$split2[1],
          n = _t$split2[2];

      return {
        chainId: "".concat(s, ":").concat(i),
        address: n
      };
    }
  }, {
    key: "setAccounts",
    value: function setAccounts(t) {
      var _this5 = this;

      this.accounts = t.filter(function (s) {
        return _this5.parseChainId(_this5.parseAccountId(s).chainId) === _this5.chainId;
      }).map(function (s) {
        return _this5.parseAccountId(s).address;
      }), this.events.emit("accountsChanged", this.accounts);
    }
  }, {
    key: "getRpcConfig",
    value: function getRpcConfig(t) {
      var _this6 = this;

      var s, i;
      return {
        chains: ((s = t.chains) == null ? void 0 : s.map(function (n) {
          return _this6.formatChainId(n);
        })) || ["".concat(this.namespace, ":1")],
        optionalChains: t.optionalChains ? t.optionalChains.map(function (n) {
          return _this6.formatChainId(n);
        }) : void 0,
        methods: (t === null || t === void 0 ? void 0 : t.methods) || p,
        events: (t === null || t === void 0 ? void 0 : t.events) || u,
        optionalMethods: (t === null || t === void 0 ? void 0 : t.optionalMethods) || [],
        optionalEvents: (t === null || t === void 0 ? void 0 : t.optionalEvents) || [],
        rpcMap: (t === null || t === void 0 ? void 0 : t.rpcMap) || this.buildRpcMap(t.chains.concat(t.optionalChains || []), t.projectId),
        showQrModal: !!(t != null && t.showQrModal),
        qrModalOptions: (i = t === null || t === void 0 ? void 0 : t.qrModalOptions) != null ? i : void 0,
        projectId: t.projectId,
        metadata: t.metadata
      };
    }
  }, {
    key: "buildRpcMap",
    value: function buildRpcMap(t, s) {
      var _this7 = this;

      var i = {};
      return t.forEach(function (n) {
        i[n] = _this7.getRpcUrl(n, s);
      }), i;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee6(t) {
        var s, _yield$import, i;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.rpc = this.getRpcConfig(t);
                this.chainId = I(this.rpc.chains);
                _context6.next = 4;
                return _universalProvider.UniversalProvider.init({
                  projectId: this.rpc.projectId,
                  metadata: this.rpc.metadata,
                  disableProviderPing: t.disableProviderPing,
                  relayUrl: t.relayUrl,
                  storageOptions: t.storageOptions
                });

              case 4:
                this.signer = _context6.sent;
                this.registerEventListeners();
                _context6.next = 8;
                return this.loadPersistedSession();

              case 8:
                if (!this.rpc.showQrModal) {
                  _context6.next = 28;
                  break;
                }

                _context6.prev = 9;
                _context6.next = 12;
                return import("@walletconnect/modal");

              case 12:
                _yield$import = _context6.sent;
                i = _yield$import.WalletConnectModal;
                s = i;
                _context6.next = 20;
                break;

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6["catch"](9);
                throw new Error("To use QR modal, please install @walletconnect/modal package");

              case 20:
                if (!s) {
                  _context6.next = 28;
                  break;
                }

                _context6.prev = 21;
                this.modal = new s(C({
                  walletConnectVersion: 2,
                  projectId: this.rpc.projectId,
                  standaloneChains: this.rpc.chains
                }, this.rpc.qrModalOptions));
                _context6.next = 28;
                break;

              case 25:
                _context6.prev = 25;
                _context6.t1 = _context6["catch"](21);
                throw this.signer.logger.error(_context6.t1), new Error("Could not generate WalletConnectModal Instance");

              case 28:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[9, 17], [21, 25]]);
      }));

      function initialize(_x5) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "loadConnectOpts",
    value: function loadConnectOpts(t) {
      var _this8 = this;

      if (!t) return;
      var s = t.chains,
          i = t.optionalChains,
          n = t.rpcMap;
      s && (0, _utils.isValidArray)(s) && (this.rpc.chains = s.map(function (e) {
        return _this8.formatChainId(e);
      }), s.forEach(function (e) {
        _this8.rpc.rpcMap[e] = (n === null || n === void 0 ? void 0 : n[e]) || _this8.getRpcUrl(e);
      })), i && (0, _utils.isValidArray)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i === null || i === void 0 ? void 0 : i.map(function (e) {
        return _this8.formatChainId(e);
      }), i.forEach(function (e) {
        _this8.rpc.rpcMap[e] = (n === null || n === void 0 ? void 0 : n[e]) || _this8.getRpcUrl(e);
      }));
    }
  }, {
    key: "getRpcUrl",
    value: function getRpcUrl(t, s) {
      var i;
      return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || "".concat(N, "?chainId=eip155:").concat(t, "&projectId=").concat(s || this.rpc.projectId);
    }
  }, {
    key: "loadPersistedSession",
    value: function () {
      var _loadPersistedSession = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var t, s;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.session) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.next = 4;
                return this.signer.client.core.storage.getItem("".concat(this.STORAGE_KEY, "/chainId"));

              case 4:
                t = _context7.sent;
                s = this.session.namespaces["".concat(this.namespace, ":").concat(t)] ? this.session.namespaces["".concat(this.namespace, ":").concat(t)] : this.session.namespaces[this.namespace];
                this.setChainIds(t ? [this.formatChainId(t)] : s === null || s === void 0 ? void 0 : s.accounts), this.setAccounts(s === null || s === void 0 ? void 0 : s.accounts);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loadPersistedSession() {
        return _loadPersistedSession.apply(this, arguments);
      }

      return loadPersistedSession;
    }()
  }, {
    key: "reset",
    value: function reset() {
      this.chainId = 1, this.accounts = [];
    }
  }, {
    key: "persist",
    value: function persist() {
      this.session && this.signer.client.core.storage.setItem("".concat(this.STORAGE_KEY, "/chainId"), this.chainId);
    }
  }, {
    key: "parseAccounts",
    value: function parseAccounts(t) {
      var _this9 = this;

      return typeof t == "string" || t instanceof String ? [this.parseAccount(t)] : t.map(function (s) {
        return _this9.parseAccount(s);
      });
    }
  }], [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee8(t) {
        var s;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                s = new m();
                _context8.next = 3;
                return s.initialize(t);

              case 3:
                return _context8.abrupt("return", s);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function init(_x6) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return m;
}();

exports["default"] = m;
var Y = m;
exports.EthereumProvider = Y;